<template>
  <v-card class="vuetify-aggregator-card" tile>
    <v-toolbar :color="color" dark>
      <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-show="$slots['card-text'] && navigationMenu" bottom left>
        <v-btn v-if="canEdit" icon slot="activator" dark>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list style="max-height: 282px" class="scroll-y">
          <v-list-tile @click="dialog = !dialog">
            <v-list-tile-title>{{ listTitle }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <slot name="card-text" v-if="$slots['card-text']"></slot>
    <v-card-text v-else>
      <div class="add-area">
        <v-tooltip bottom>
          <v-btn v-show="addButton" slot="activator" fab dark :color="color" 
        @click="dialog = true">
            <v-icon dark large>add</v-icon>
          </v-btn>
          <span>{{ addButtonHoverText }}</span>
        </v-tooltip>
      </div>
    </v-card-text>
    <v-dialog v-model="dialog" :max-width="dialogMaxWidth" :persistent="persistent">
      <slot name="dialog"></slot>
      <v-card v-if="!$slots['dialog']" tile>
              <v-card-title class="headline">
                {{ dialogToolbarTitle }}
              </v-card-title>
        <v-card-text>
          <slot name="dialog-card-text"></slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <slot name="dialog-card-actions"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <slot name="extras"></slot>
  </v-card>
</template>

<script>

'use strict'

export default {

  name: 'VuetifyAggregatorCard',

  props: {
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    persistent: {
      type: Boolean,
      default: false,
      required: false
    },
    canEdit: {
      type: Boolean,
      default: true,
      required: false
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    addButton: {
      type: Boolean,
      default: true,
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data: () => ({
    dialog: false
  })
}
</script>

<style lang="sass">
.vuetify-aggregator-card
  margin-bottom: 20px
</style>


// WEBPACK FOOTER //
// src/layouts/vuetify-aggregator-card.vue